import React, { Component } from 'react'
import { ChevronsDown, ChevronsLeft, ChevronsRight, ChevronsUp } from 'lucide-react'
import { HoverTooltip } from '../HoverTooltip'
import { TableBox } from './TableBox'
import './DualTableList.css'

class DualTableList extends Component {
    addElement = (event) => {
        const { selected, onChange } = this.props
        onChange([...selected, event.data.id])
    }

    removeElement = (event) => {
        const { selected, onChange } = this.props
        onChange(selected.filter(id => id !== event.data.id))
    }

    addAll = () => {
        const { objects, selected, onChange } = this.props
        const selectedSet = new Set(selected)
        const nonSelectedIds = objects.filter(o => !selectedSet.has(o.id)).map(o => o.id)
        onChange([...selected, ...nonSelectedIds])
    }

    removeAll = () => {
        this.props.onChange([])
    }

    renderButtons(isVertical) {
        const { disabled, t } = this.props
        return (
            <div className={isVertical ? 'DualTableList-Buttons--horizontal' : 'DualTableList-Buttons--vertical'}>
                <HoverTooltip
                    id="DualTableList-addAll-tooltip"
                    message={t('addAllElements')}
                    placement={isVertical ? 'right' : 'bottom'}
                >
                    <button
                        className="btn btn-default TableBox-BoardButton"
                        type="button"
                        disabled={disabled}
                        onClick={this.addAll}
                    >
                        {isVertical ? <ChevronsDown size={17} /> : <ChevronsRight size={17} />}
                    </button>
                </HoverTooltip>
                <HoverTooltip
                    id="DualTableList-removeAll-tooltip"
                    message={t('removeAllElements')}
                    placement={isVertical ? 'right' : 'bottom'}
                >
                    <button
                        className="btn btn-default TableBox-BoardButton"
                        type="button"
                        disabled={disabled}
                        onClick={this.removeAll}
                    >
                        {isVertical ? <ChevronsUp size={17} /> : <ChevronsLeft size={17} />}
                    </button>
                </HoverTooltip>
            </div>
        )
    }

    render() {
        const { objects, selected, columns, path, leftBoxTKey, height, required, disabled, displayMode = 'horizontal', t } = this.props

        const selectedSet = new Set(selected)
        const nonSelectedObjects = objects.filter(o => !selectedSet.has(o.id))
        const selectedObjects = objects.filter(o => selectedSet.has(o.id))
        const isVertical = displayMode === 'vertical'

        const leftBox = (
            <div className={`TableBox-container${isVertical ? ' TableBox-container--vertical' : ''}`}>
                <label className="TableBox-label">{t(leftBoxTKey || path)} {required && '*'}</label>
                <TableBox
                    objects={nonSelectedObjects}
                    columns={columns}
                    position="left"
                    onRowClick={this.addElement}
                    disabled={disabled}
                    height={height}
                    t={t}
                />
            </div>
        )

        const rightBox = (
            <div className={`TableBox-container${isVertical ? ' TableBox-container--vertical' : ''}`}>
                <label className="TableBox-label">{t(path)} {required && '*'}</label>
                <TableBox
                    objects={selectedObjects}
                    columns={columns}
                    position="right"
                    onRowClick={this.removeElement}
                    disabled={disabled}
                    height={height}
                    t={t}
                />
            </div>
        )

        return (
            <div className={`DualTableList-Container${isVertical ? ' DualTableList-Container--vertical' : ''} px-4`}>
                {leftBox}
                {this.renderButtons(isVertical)}
                {rightBox}
            </div>
        )
    }
}

export default DualTableList